"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _i18n = require("../../../../i18n");
const usePhotosOptions = _ref => {
  let {
    components,
    name
  } = _ref;
  const {
    T
  } = (0, _i18n.useTranslation)();
  const options = [{
    label: T.translate('optionalComponents.photos.singular'),
    value: 1
  }, {
    label: T.translate('optionalComponents.photos.regular'),
    value: 2
  }, {
    label: T.translate('optionalComponents.photos.plural', {
      perRow: 3
    }),
    value: 3
  }, {
    label: T.translate('optionalComponents.photos.plural', {
      perRow: 4
    }),
    value: 4
  }, {
    label: T.translate('optionalComponents.photos.plural', {
      perRow: 5
    }),
    value: 5
  }];
  const getDefaultValue = (components, options) => {
    if (name === 'photos') {
      if (components.photos.value) {
        return options.find(option => option.value === components.photos.value);
      } else {
        return options[1];
      }
    }
    return {
      value: null
    };
  };
  const defaultValue = getDefaultValue(components, options);
  return [options, defaultValue];
};
var _default = exports.default = usePhotosOptions;